import React from 'react';
import {Outlet} from "react-router-dom";

const LayoutPublic = () => {
    return (
        <div className="LayoutPublic">
            <Outlet/>
        </div>
    );
};

export default LayoutPublic;